import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';
import {formatters} from './../core';

@Pipe({
    name: 'formatDateTime'
})
export class FormatDateTimePipe implements PipeTransform {
    public transform(value: moment.Moment): string {
        return formatters.formatDateTime(value);
    }
}